import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Input } from "@/components/ui/input";
import { LogIn, Chrome } from 'lucide-react';
import { toast } from 'sonner';

export default function LoginPage() {
  const { login, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const from = location.state?.from?.pathname || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      toast.error('Email and password required');
      return;
    }

    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back, soldier!');
      navigate(from, { replace: true });
    } catch (error) {
      toast.error(error.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="login-page">
      <div className="w-full max-w-sm">
        {/* Logo */}
        <div className="text-center mb-8">
          <h1 className="ws-logo text-3xl">
            <span className="ws-logo-war">WAR</span>
            <span className="ws-logo-syndicate">SYNDICATE</span>
          </h1>
          <p className="text-[#666] text-xs mt-2">ENTER YOUR CREDENTIALS</p>
        </div>

        <div className="bg-[#111] border border-[#333] p-6">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-xs text-[#666] uppercase mb-2 block">Email</label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="bg-black border-[#333] text-[#44ff44] placeholder:text-[#444] focus:border-[#cc0000]"
                data-testid="login-email"
              />
            </div>

            <div>
              <label className="text-xs text-[#666] uppercase mb-2 block">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="bg-black border-[#333] text-[#44ff44] placeholder:text-[#444] focus:border-[#cc0000]"
                data-testid="login-password"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full btn-primary py-2.5 flex items-center justify-center gap-2"
              data-testid="login-submit"
            >
              <LogIn size={16} />
              {loading ? 'AUTHENTICATING...' : 'LOGIN'}
            </button>
          </form>

          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-[#333]" />
            </div>
            <div className="relative flex justify-center text-xs">
              <span className="bg-[#111] px-2 text-[#666]">OR</span>
            </div>
          </div>

          <button
            onClick={loginWithGoogle}
            className="w-full btn-secondary py-2.5 flex items-center justify-center gap-2"
            data-testid="login-google"
          >
            <Chrome size={16} />
            CONTINUE WITH GOOGLE
          </button>

          <p className="text-center text-xs text-[#666] mt-6">
            New recruit?{' '}
            <Link to="/register" className="text-[#ffcc00] hover:text-[#ffd700]">
              CREATE ACCOUNT
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
